/**
 * LiveKit raise-hand data-channel types.
 */

export const LIVE_HAND_TYPE = "codelive.hand" as const;

export type HandRaiseEntry = {
  student_id: string;
  student_name: string;
  raised_at: number;
};

export type LiveHandMessage = {
  type: typeof LIVE_HAND_TYPE;
  v: 1;
  student_id: string;
  student_name: string;
  raised: boolean;
  at: number;
};
